import { render, staticRenderFns } from "./powProcess.vue?vue&type=template&id=cfdda15e&scoped=true&"
import script from "./powProcess.vue?vue&type=script&lang=js&"
export * from "./powProcess.vue?vue&type=script&lang=js&"
import style0 from "./powProcess.vue?vue&type=style&index=0&id=cfdda15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdda15e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfdda15e')) {
      api.createRecord('cfdda15e', component.options)
    } else {
      api.reload('cfdda15e', component.options)
    }
    module.hot.accept("./powProcess.vue?vue&type=template&id=cfdda15e&scoped=true&", function () {
      api.rerender('cfdda15e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/pow/powProcess.vue"
export default component.exports